import React from 'react';
import translate from 'components/hoc/translate';
import PropTypes from 'prop-types';
import Header from 'components/ui/general/Header';
import Title from 'components/ui/general/Title';
import CreateButton from 'components/button/CreateButton';
import Actions from 'components/ui/general/Actions';
import ResourceList from 'components/list/Container/ResourceList';
import Table from 'components/table/Table';
import TextField from 'components/field/TextField';
import theme from 'theme/theme';
import { fetchProductMemberships } from 'store/actions/product-memberships/fetchProductMemberships';
import ProductField from 'components/field/ProductField';
import StatusField from 'components/field/StatusField';
import MembershipScheduleField from 'components/field/MembershipScheduleField';
import { compose } from 'recompose';
import listQueryFilter from 'components/hoc/listQueryFilter';
import ProductMembershipListFilters from './ProductMembershipListFilters';

function ProductMemberships({ resource, translate, actionType, updateQuery, ...props }) {
    return (
        <div>
            <Header>
                <Title title={ translate('menu.sidebar.product_memberships') } />

                <Actions>
                    <CreateButton basePath={ resource } />
                </Actions>
            </Header>

            <ProductMembershipListFilters
                actionType={ actionType }
                location={ props.location }
                resource={ resource }
                updateQuery={ updateQuery }
            />

            <ResourceList
                action={ fetchProductMemberships }
                actionType={ actionType }
                location={ location }
                resource={ resource }
                updateQuery={ updateQuery }
            >
                <Table
                    backgroundToggle={ {
                        condition: true,
                        color: theme.palette.chinook,
                        key: 'id',
                    } }
                >
                    <TextField
                        { ...props }
                        column={ {
                            sortable: false,
                            width: '20%',
                        } }
                        source='name'
                        label={ translate('filters.components.name.label') }
                    />

                    <ProductField
                        column={ {
                            sortable: false,
                        } }
                        label='resources.reservations.fields.product'
                        source='product_id'
                    />

                    <MembershipScheduleField
                        column={ {
                            sortable: false,
                        } }
                        label='resources.product_memberships.fields.membership_schedule'
                        source='membership_schedule_id'
                    />

                    <StatusField
                        column={ {
                            align: 'center',
                            link: false,
                            sortable: false,
                            width: '15%',
                        } }
                        label='resources.product_memberships.fields.supports_ondemand'
                        source='supports_ondemand'
                    />

                    <StatusField
                        column={ {
                            align: 'center',
                            link: false,
                            sortable: false,
                            width: '15%',
                        } }
                        label='resources.product_memberships.fields.supports_scheduled'
                        source='supports_scheduled'
                    />

                    <StatusField
                        column={ {
                            align: 'center',
                            link: false,
                            sortable: false,
                            width: '10%',
                        } }
                        label='resources.products.fields.is_visible'
                        source='is_visible'
                    />

                </Table>
            </ResourceList>
        </div>
    );
}

ProductMemberships.propTypes = {
    actionType: PropTypes.string.isRequired,
    location: PropTypes.object.isRequired,
    resource: PropTypes.string.isRequired,
    translate: PropTypes.func.isRequired,
    updateQuery: PropTypes.func.isRequired,
};

const enhance = compose(
    translate,
    listQueryFilter,
);

export default enhance(ProductMemberships);


// WEBPACK FOOTER //
// ./src/pages/product-memberships/list/ProductMemberships.js